// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"389":"b75c2e52","400":"49cd2332","656":"d0b1ea3b","781":"f6d23941","795":"5379fa7c"}[chunkId] + ".css";
};